interface CycleCompletedHeaderProps {
  cycleNumber: number;
  expanded: boolean;
  onToggle: () => void;
  titleClassName?: string;
}

/** Collapsible completed-cycle header with checkmark. */
export default function CycleCompletedHeader({
  cycleNumber,
  expanded,
  onToggle,
  titleClassName = 'text-lg font-bold text-gray-800',
}: CycleCompletedHeaderProps) {
  return (
    <div
      className="flex items-center justify-between mb-4 cursor-pointer"
      onClick={onToggle}
    >
      <div className="flex items-center gap-3">
        <h2 className={titleClassName}>Cycle {cycleNumber}</h2>
        <div className="w-6 h-6 rounded-full bg-green-500 flex items-center justify-center">
          <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
      </div>
      <svg
        className={`w-5 h-5 text-gray-500 ${expanded ? 'rotate-180' : ''}`}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
      </svg>
    </div>
  );
}
